import { useEffect, useState } from "react";
import { api, eur } from "../../lib/api";

export default function AdminAi() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/ai-usage").then((r) => setData(r.data));
  }, []);

  if (!data) return <div className="text-sm font-mono text-zinc-500">Laden…</div>;

  return (
    <div className="space-y-6" data-testid="admin-ai-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-wider text-zinc-500">Plattform</div>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight mt-1">KI-Nutzung & Kosten</h1>
        <p className="text-sm text-zinc-500 mt-1">Monat {data.month} · {data.total} KI-Imports gesamt · geschätzte Kosten basieren auf Ø 0,04 €/Analyse.</p>
      </div>
      <div className="bg-white border border-zinc-200 rounded-xl shadow-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[600px]">
          <thead><tr className="border-b border-zinc-200 text-left">
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500">Unternehmen</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500">Tarif</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500 text-right">KI-Imports (Monat)</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500 text-right">Geschätzte Kosten</th>
          </tr></thead>
          <tbody className="divide-y divide-zinc-50">
            {data.rows.length === 0 && <tr><td colSpan={4} className="px-5 py-8 text-center text-zinc-500">Noch keine KI-Nutzung in diesem Monat.</td></tr>}
            {data.rows.map((r) => (
              <tr key={r.tenant_id} data-testid={`ai-usage-${r.company}`}>
                <td className="px-5 py-3 font-medium">{r.company}</td>
                <td className="px-5 py-3 font-mono text-xs text-zinc-400">{r.plan}</td>
                <td className="px-5 py-3 text-right font-mono">{r.imports_month}</td>
                <td className="px-5 py-3 text-right">{eur(r.est_cost)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
